export default __webpack_public_path__ + "static/media/strawberryTtsIt_It60.cc14edc8.mp3";